import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
export default function Strike(props) {
  return /*#__PURE__*/React.createElement("span", _extends({}, props.dataAttributes, {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    style: {
      textDecoration: 'line-through'
    }
  }), props.children);
}